<template>
  <div class="col-lg-12">
    <label>Selecione a opção correta</label>
    <select class="form-control" v-model="choices.correctAnswer">
      <option value="yes">Sim</option>
      <option value="no">Não</option>
      <option value="any">Qualquer uma</option>
    </select>
  </div>
</template>

<script>
export default {
  props: ["value", "index"],
  data: () => ({
    choices: {
      correctAnswer: "any",
    },
  }),
  mounted() {
    if (this.value && Object.keys(this.value).length > 0)
      this.choices = this.value;
    this.updateOptions();
  },
  methods: {
    updateOptions() {
      this.$emit("input", this.choices);
      eventBus.$emit("updateQuestions", []);
    },
  },
};
</script>